var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"smart2_Com_1"},[_c('title1',{attrs:{"type":"1","title":"已有各类型场站统计"}}),_c('div',{ref:"pieone",staticClass:"pieon",attrs:{"id":"pieon2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }